export default __webpack_public_path__ + "static/neuralNetworks-0770b908d6402c8d41821760e7b8d127.png";